export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Centre de langues & Bureau d'immigration",
  headLine: "International Academy",
  description:
    "est un centre de langue et bureau d'immigration qui propose plusieurs services allant de l'enseignement des langues, la préparation des tests de langues à l'aide au demarche pour l'immigration",
  buttonLabel: "Plus d'infos",
  imgStart: false,
  img: require("../../images/logo-iac.png").default,
  alt: "International Academy logo",
  dark: false,
  primary: false,
  darkText: false,
};

export const homeObjTwo = {
  id: "partenariat",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Partenariat & Ausbildung",
  headLine: "Intermediaire unique",
  description:
    "International Academy est un interloccuteur de choix, qui vous aidera à trouver l'entreprise qui vous convient en Allemagne que cela soit pour une formation professionnelle ou un contrat de travail",
  buttonLabel: "Nous contacter",
  imgStart: true,
  img: require("../../images/partenariat.svg").default,
  alt: "International Academy partenariat",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "E-learning",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "E-learning",
  headLine: "Cours à distance",
  description:
    "International Academy offre des cours en ligne pour s'adapter à tous les horaires et donner accès à ses cours au plus grand nombre",
  buttonLabel: "Inscription",
  imgStart: false,
  img: require("../../images/e-learning.svg").default,
  alt: "International Academy e-learning",
  dark: false,
  primary: false,
  darkText: false,
};
